import React, { FunctionComponent } from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { IBindingAction, IBindingCallback1 } from '../../../../common/models/callback';
import { IProspectCreate } from '../../../../common/models/prospect/IProspectCreate';
import { IProspectForm } from '../../../../common/models/prospect/IProspectForm';
import { IAppState } from '../../../../common/models/store/IAppState';
import ProspectForms from '../../components/ProspectForms';
import ProspectIntro from '../../components/ProspectIntro';
import { createProspectRoutine } from '../../routines';
import { ProspectPages } from './utils';

interface IProps extends RouteComponentProps {
  isPreview: boolean;
  workEndDate: Date | null;
  title: string;
  workInCompany: string;
  contactId: string;
  candidateId: string;
  companyName: string;
  optInText: string | undefined;
  currentPage: ProspectPages;
  logo: string | undefined;
  isManualInput: boolean;
  onThank: IBindingAction;
  createProspect: IBindingCallback1<{ data: IProspectCreate; isManualInput: boolean }>;
  setCurrentPage: IBindingCallback1<ProspectPages>;
}

const Prospect: FunctionComponent<IProps> = ({
  isManualInput,
  isPreview,
  workEndDate,
  title,
  workInCompany,
  companyName,
  contactId,
  candidateId,
  optInText,
  logo,
  currentPage,
  setCurrentPage,
  onThank,
  createProspect,
  history
}) => {
  const onNextPage = () => {
    if (isManualInput) {
      history.goBack();
    } else {
      onThank();
    }
  };

  const onCreateProspect = (values: IProspectForm) => {
    if (!isPreview) {
      const prospect = {
        contactId,
        sourceCandidateId: candidateId,
        currentCompany: values.currentCompany?.trim() || undefined,
        currentPosition: values.currentPosition?.trim() || undefined,
        profileLink: values.profileLink?.trim() || undefined
      };
      createProspect({ data: prospect, isManualInput });
    }
    onNextPage();
  };

  const getCurrentComponent = () => {
    switch (currentPage) {
      case ProspectPages.Intro:
        return (
          <ProspectIntro
            onConfirm={() => setCurrentPage(ProspectPages.Forms)}
            onCancel={onNextPage}
            companyName={companyName}
            optInText={optInText}
            companyLogo={logo}
          />
        );
      case ProspectPages.Forms:
        return (
          <ProspectForms
            onConfirm={onCreateProspect}
            isPreview={isPreview}
            referenceData={workEndDate ? {} : { role: title, employer: workInCompany }}
          />
        );
      default:
        return <></>;
    }
  };

  return getCurrentComponent();
};

const mapStateToProps = ({
  refSurvey: {
    isManualInput,
    reference: { workEndDate, title, workInCompany, email, phoneNumber, contactId },
    candidate: { id } },
  workspace: { name, logo, optInText }
}: IAppState) => ({
  workEndDate,
  title: title as string,
  workInCompany: workInCompany as string,
  companyName: name,
  email,
  phoneNumber,
  candidateId: id,
  optInText,
  logo,
  contactId,
  isManualInput
});

const mapDispatchToProps = {
  createProspect: createProspectRoutine
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Prospect));
